/* eslint-disable unicorn/filename-case */
import { Emitter } from "strict-event-emitter";
import { Deferred } from "../lib/Deferred";
export class DialogManager {
    _currentState = null;
    _defaultProps;
    _emitter;
    constructor(defaultProps) {
        this._defaultProps = defaultProps || {};
        this._emitter = new Emitter();
        // Don't warn about potential memory leaks until register at least 30
        // listeners since dialogs can be triggered from things like table rows.
        this._emitter.setMaxListeners(30);
    }
    get currentDialog() {
        return this._currentState?.props ?? null;
    }
    subscribe(eventName, callback) {
        this._emitter.on(eventName, callback);
        return () => this._emitter.off(eventName, callback);
    }
    alert(props) {
        if (this._currentState) {
            this.cancel();
        }
        this._currentState = {
            type: "alert",
            deferred: new Deferred(),
            props: {
                type: "alert",
                ...this._defaultProps,
                ...props,
            },
        };
        this._emitter.emit("change", this._currentState.props);
        return this._currentState.deferred.promise;
    }
    confirm(props) {
        if (this._currentState) {
            this.cancel();
        }
        this._currentState = {
            type: "confirm",
            deferred: new Deferred(),
            props: {
                type: "confirm",
                ...this._defaultProps,
                ...props,
            },
        };
        this._emitter.emit("change", this._currentState.props);
        return this._currentState.deferred.promise;
    }
    prompt(props) {
        if (this._currentState) {
            this.cancel();
        }
        this._currentState = {
            type: "prompt",
            deferred: new Deferred(),
            props: {
                type: "prompt",
                ...this._defaultProps,
                ...props,
            },
        };
        this._emitter.emit("change", this._currentState.props);
        return this._currentState.deferred.promise;
    }
    ok(inputValue) {
        if (!this._currentState) {
            return;
        }
        switch (this._currentState.type) {
            case "alert": {
                // window.alert always returns `undefined` when the button is clicked
                // treat modal the same as alert.
                this._currentState.deferred.resolve(undefined);
                break;
            }
            case "confirm": {
                // window.confirm returns `true` on "ok" click
                this._currentState.deferred.resolve(true);
                break;
            }
            case "prompt": {
                // window.prompt returns the value of the input or "" if no input
                this._currentState.deferred.resolve(inputValue ?? null);
                break;
            }
        }
        this._currentState = null;
        this._emitter.emit("change", null);
    }
    cancel() {
        if (!this._currentState) {
            return;
        }
        switch (this._currentState.type) {
            case "alert": {
                // window.alert always returns `undefined` when the button is clicked.
                this._currentState.deferred.resolve(undefined);
                break;
            }
            case "confirm": {
                // window.confirm returns `false` on "cancel" click
                this._currentState.deferred.resolve(false);
                break;
            }
            case "prompt": {
                // window.prompt returns the value of the input or `null` if no input
                this._currentState.deferred.resolve(null);
                break;
            }
        }
        this._currentState = null;
        this._emitter.emit("change", null);
    }
}
//# sourceMappingURL=DialogManager.js.map